<app-elevation-section [title]="title"
                       [hasShowButton]="hasShowButton"
                       (showClicked)="onShowClicked()">
  <dx-data-grid #datagriddx rowAlternationEnabled="true"
                [class]="classes"
                [class.space-between-grid-and-actions]="hasSearch"
                [dataSource]="dataSource"
                [columns]="columns"
                [columnAutoWidth]="true"
                (onRowClick)="onRowClicked($event)"
                (onExporting)="exporting($event)"
                (onSelectionChanged)="onSelectionChanged($event)">
    <dxo-paging [pageSize]="20"></dxo-paging>
    <dxo-search-panel [visible]="hasSearch" width="240"></dxo-search-panel>
    <dxo-header-filter [visible]="hasFilter"></dxo-header-filter>
    <dxo-export [enabled]="hasExport"></dxo-export>
    <dxo-group-panel [visible]="hasGrouping"></dxo-group-panel>
    <dxo-grouping [autoExpandAll]="true"></dxo-grouping>
    <dxo-summary [groupItems]="groupItems"></dxo-summary>
    <dxo-selection [selectAllMode]="selectAllMode"
                   [showCheckBoxesMode]="showCheckBoxesMode"
                   [mode]="selectMode"></dxo-selection>
    <dxo-state-storing [enabled]="storageKey" type="localStorage" [storageKey]="storageKey"></dxo-state-storing>
  </dx-data-grid>
</app-elevation-section>
